enum ROLE {
  ADMIN = 'admin',
  USER = 'user',
  SUPER_ADMIN = 'super admin',
}

export default ROLE;
